import { GET_PERSON_NAMES } from "constants/v1";

export default (state = [], action) => {
  switch (action.type) {
    case `${GET_PERSON_NAMES}_SUCCESS`:
      return action.payload;
    default:
      return state;
  }
};
